var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddCartIcon = function SvgAddCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "second-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108684",
    d: "M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 18.889A8.889 8.889 0 1 1 18.889 10 8.9 8.9 0 0 1 10 18.889Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108685",
    d: "M12.779 9.445h-2.218V7.223a.556.556 0 1 0-1.111 0v2.222H7.228a.556.556 0 1 0 0 1.111H9.45v2.222a.555.555 0 1 0 1.11 0v-2.222h2.222a.555.555 0 0 0 0-1.11Z"
  }))));
};
export default SvgAddCartIcon;